import { render } from "./DealerBenefits.vue?vue&type=template&id=4b5ab468"
const script = {}

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__